<template>
  <a-config-provider :locale="locale()" global>
    <el-config-provider :locale="locale('Elem')">
      <router-view />
    </el-config-provider>
  </a-config-provider>
</template>

<script setup>
  import { onMounted, onUnmounted, ref } from "vue";
  import { menuStore } from "@/store/modules/menuUse.js";

  const beforeUnloadTime = ref();

  // 记录时间
  const recordBeforeUnloadTime = () => {
    beforeUnloadTime.value = new Date().getTime();
  };
  // 在页面关闭后，清除已打开的tabs
  const handleClearTabs = () => {
    const unloadTime = new Date().getTime();
    // 关闭和刷新的时间差小于5，清除tabs
    if (unloadTime - beforeUnloadTime.value <= 5) {
      const { setTabList } = menuStore();
      setTabList();
    }
  };

  onMounted(function () {
    window.addEventListener("beforeunload", recordBeforeUnloadTime);
    window.addEventListener("unload", handleClearTabs);
  });
  onUnmounted(function () {
    window.removeEventListener("beforeunload", recordBeforeUnloadTime);
    window.removeEventListener("unload", handleClearTabs);
  });
</script>
<script>
  import i18nMix from "@/mixin/i18n.js";
  export default {
    mixins: [i18nMix],
  };
</script>

<style lang="scss">
  @import "@/assets/css/main.scss";
</style>
